import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { userDetailsContext } from "../Context";
import { FaShoppingCart } from "react-icons/fa";

const Navbar = () => {
	const { length, setLength } = useContext(userDetailsContext);
	const [lengths, setlength] = useState("1");
	useEffect(() => {
		console.log(localStorage.getItem("cart"));
		if (localStorage.getItem("cart")) {
			console.log("hello");
		}
		if (localStorage.getItem("cart")) {
			let cartdata = [...JSON.parse(localStorage.getItem("cart"))];
			setLength(cartdata.length);
		} else setLength(0);
		setlength(length);
	}, [length, setLength]);
	return (
		<nav className=' bg-custom-blue h-12 flex'>
			<div className='flex justify-between items-center w-72 sm:w-11/12 mx-auto'>
				<h1 className=' uppercase text-gray-100 text-lg sm:text-2xl font-bold '>
					<Link to='/'>Mega shopping</Link>
				</h1>
				<div className='relative'>
					<Link to='/cart' className='  text-gray-100  inline-block '>
						<FaShoppingCart className='text-lg sm:text-2xl' />
					</Link>
					<sup className=' bg-custom-green text-white p-2 rounded absolute '>{lengths}</sup>
				</div>
			</div>
		</nav>
	);
};

export default Navbar;
